// Reine Regeln für „Zur Ablage“ (Handoff Dokumente §6.3).

import { istHoheSicherheit } from './kennzahlen';

export type AblageSegment = 'offen' | 'abgelegt' | 'abgelehnt';

/** Status, die als „Offen“ zählen (freigegeben/fehler sind noch nicht in Drive). */
export const OFFENE_STATUS = ['offen', 'freigegeben', 'fehler'] as const;
export const SEGMENT_STATUS: Record<AblageSegment, readonly string[]> = {
  offen: OFFENE_STATUS, abgelegt: ['abgelegt'], abgelehnt: ['abgelehnt'],
};

export const segmentVonStatus = (status: string): AblageSegment =>
  status === 'abgelegt' ? 'abgelegt' : status === 'abgelehnt' ? 'abgelehnt' : 'offen';

export interface AblageBereit {
  objekt_id: string | null; ziel_pfad: string | null; dateiname: string | null;
  graph_message_id: string | null; graph_attachment_id: string | null;
}

/** Fehlt etwas fürs Ablegen? null = bereit, sonst der Hinweis für die Karte. */
export function ablageHinweis(v: AblageBereit): string | null {
  if (!v.graph_message_id || !v.graph_attachment_id) return 'Keine Postfach-Referenz – Anhang neu synchronisieren.';
  if (!v.objekt_id) return 'Bitte ein Zielobjekt wählen.';
  if (!(v.ziel_pfad ?? '').trim()) return 'Keine Regel hat gepasst – bitte Zielordner wählen.';
  if (!(v.dateiname ?? '').trim()) return 'Bitte einen Dateinamen eingeben.';
  return null;
}

/** Kandidat für „Alle ≥ 90 % ablegen“: hohe Sicherheit und vollständig. */
export const fuerMassenablage = (v: AblageBereit & { confidence: number }) => istHoheSicherheit(v.confidence) && ablageHinweis(v) === null;

export const ABSENDER_TYP: Record<string, string> = {
  mieter: 'Mieter', eigentuemer: 'Eigentümer', dienstleister: 'Dienstleister', behoerde: 'Behörde', sonstige: 'Sonstige',
};
export const absenderTypLabel = (t: string | null | undefined) => (t ? ABSENDER_TYP[t] ?? t : null);

/** Farbe des Sicherheitsbalkens. */
export const sicherheitTon = (c: number): 'ok' | 'warn' | 'bad' => (istHoheSicherheit(c) ? 'ok' : c >= 0.5 ? 'warn' : 'bad');

/** Herkunft des Vorschlags: Regelname, sonst KI bzw. ohne Regel. */
export function herkunftLabel(regelName: string | null | undefined, confidence: number): string {
  if (regelName) return `Regel: ${regelName}`;
  return confidence >= 0.5 ? 'KI-Vorschlag' : 'Ohne Regel';
}
